// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PS5Badge_badge__ke-2g {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  z-index: -1;
}
.PS5Badge_inner__fWuAk {
  border-radius: 0px 0px 16px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 12px;
  max-width: 500px;
}
.PS5Badge_icon__DlwMA {
  display: flex;
  justify-content: center;
  align-items: center;
}
.PS5Badge_icon__DlwMA img {
  width: 86px;
  height: 14px;
  flex-shrink: 0;
}
.PS5Badge_title__t1Ubb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: center;
  width: 100%;
}
.PS5Badge_title__t1Ubb span {
  color: #fff;
  text-align: right;
  font-feature-settings: "ss01" on;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 24px;
}
.PS5Badge_title__t1Ubb image {
}

@media screen and (min-width: 1000px) {
  .PS5Badge_inner__fWuAk {
    max-width: 468px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PS5Badge/PS5Badge.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".badge {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100% !important;\n  z-index: -1;\n}\n.inner {\n  border-radius: 0px 0px 16px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n  padding: 12px;\n  max-width: 500px;\n}\n.icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.icon img {\n  width: 86px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  width: 100%;\n}\n.title span {\n  color: #fff;\n  text-align: right;\n  font-feature-settings: \"ss01\" on;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 24px;\n}\n.title image {\n}\n\n@media screen and (min-width: 1000px) {\n  .inner {\n    max-width: 468px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `PS5Badge_badge__ke-2g`,
	"inner": `PS5Badge_inner__fWuAk`,
	"icon": `PS5Badge_icon__DlwMA`,
	"title": `PS5Badge_title__t1Ubb`
};
export default ___CSS_LOADER_EXPORT___;
